/*eslint no-script-url: 0 */
import React, { Component } from "react";
//import Constants from '../../Config/Config';
import { Loader, getPlaqueSize } from "../../Helpers/Helpers";
import classNames from "classnames";
import { fabric } from "fabric";
//import Sizes from "../../Tabs/Sizes";
import $ from "jquery";
import "./fabric-smart-object.js";
var FontFaceObserver = require("fontfaceobserver");

var q,
  v = Math.PI / 180;
var canvas;
var matWidth = 0;
var grid = 0;
var frameCanvas = [];
var plauqeData = {};
var plauqeGroup;
var matWindowValues = [];
var matPlauqeValues = [];
var dstFrame;
var dstFrameCtx;

export default class FrameImageWork extends Component {
  constructor(props) {
    super(props);
    this.state = {
      frameIsLoading: false,
    };
    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    this.prepareCanvas();
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  get ratio() {
    const { leftWidth, rightFrameHeight } = this.props;
    if (parseFloat(this.width) !== 0 && parseFloat(this.height) !== 0) {
      const outerPadding = 10;
      return Math.min(
        (leftWidth - outerPadding) / this.width,
        (rightFrameHeight - outerPadding) / this.height
      );
    } else return 1;
  }

  get q() {
    const { matOuterWidth, matOuterHeight, selectedFrame } = this.props;
    if (
      parseFloat(matOuterWidth) !== 0 &&
      parseFloat(matOuterHeight) !== 0 &&
      matOuterWidth !== "" &&
      matOuterHeight !== ""
    ) {
      if (selectedFrame.size > 0) {
        var typeWidth = selectedFrame.getIn(["dimensions", "width"]);
        q = Math.min(
          1e3 /
            (parseFloat(matOuterWidth) +
              parseFloat(typeWidth) +
              parseFloat(typeWidth)),
          1e3 /
            (parseFloat(matOuterHeight) +
              parseFloat(typeWidth) +
              parseFloat(typeWidth))
        );
      } else {
        q = Math.min(
          1e3 / parseFloat(matOuterWidth),
          1e3 / parseFloat(matOuterHeight)
        );
      }
    } else q = 1;
    return q;
  }

  get width() {
    const {
      selectedmatBoard,
      middleMatGapInCM,
      selectedMatSize,
      matOuterWidth,
      selectedFrame,
    } = this.props;

    var aWidth;

    const matOuterWidthVar = matOuterWidth === "" ? 0 : matOuterWidth;

    if (selectedFrame.size > 0) {
      var typeWidth = selectedFrame.getIn(["dimensions", "width"]);
      aWidth =
        (parseFloat(matOuterWidthVar) +
          parseFloat(typeWidth) +
          parseFloat(typeWidth)) *
        this.q;
    } else {
      aWidth = parseFloat(matOuterWidthVar) * this.q;
    }

    // middle mat
    if (parseFloat(selectedMatSize) === 2) {
      matWidth = parseFloat(middleMatGapInCM) * this.q;
      aWidth = aWidth + matWidth * 2 * parseFloat(selectedmatBoard.get("rows"));
    } else {
      matWidth = 0;
    }

    return aWidth;
  }

  get height() {
    const {
      selectedmatBoard,
      middleMatGapInCM,
      selectedMatSize,
      matOuterHeight,
      selectedFrame,
    } = this.props;

    var aHeight;
    const matOuterHeighthVar = matOuterHeight === "" ? 0 : matOuterHeight;

    if (selectedFrame.size > 0) {
      var typeWidth = selectedFrame.getIn(["dimensions", "width"]);
      aHeight =
        (parseFloat(matOuterHeighthVar) +
          parseFloat(typeWidth) +
          parseFloat(typeWidth)) *
        this.q;
    } else {
      aHeight = parseFloat(matOuterHeighthVar) * this.q;
    }

    // middle mat
    if (parseFloat(selectedMatSize) === 2) {
      matWidth = parseFloat(middleMatGapInCM) * this.q;
      aHeight =
        aHeight + matWidth * 2 * parseFloat(selectedmatBoard.get("cols"));
    } else {
      matWidth = 0;
    }

    return aHeight;
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.selectedFrame !== this.props.selectedFrame &&
      this.props.selectedFrame.size > 0
    ) {
      //console.log(this.props.selectedFrame)
      this.updateCanvasForFrame();
    } else {
      if (prevProps.plaqueUpdated !== this.props.plaqueUpdated)
        this.drawPlaqueInit();

      if (prevProps.matUpdated !== this.props.matUpdated) this.init();

      if (prevProps.matWindowUpdated !== this.props.matWindowUpdated)
        this.updateObj();

      if (
        prevProps.matOuterUpdated !== this.props.matOuterUpdated ||
        prevProps.matsUpdated !== this.props.matsUpdated ||
        prevProps.isGrid !== this.props.isGrid ||
        prevProps.equalSpacing !== this.props.equalSpacing
      )
        this.updateCanvas();
    }
  }

  prepareCanvas() {
    var self = this;
    this.setState({ frameIsLoading: true });

    // intialize canvas
    canvas = window._canvas = new fabric.Canvas("framepreview");
    //canvas.selection = true;

    canvas.on("mouse:down", function(e) {
      console.log(e);
      // clicked item will be
      if (e.target) {
        const unique_id = e.target.windowID;
        if (unique_id !== undefined) {
          console.log(unique_id, "windowID");
          self.props.dispatch({
            type: "SET_STATE",
            state: {
              updatingWindow: unique_id,
            },
          });
          $(".under_the_image").show("fast");
          $(".cont_rgt_middle_table").hide("fast");
        }
      }
    });

    // object moving
    canvas.on("object:moving", function(options) {
      self.onObjectMoving(options);
    });

    canvas.on("object:moved", function(options) {
      self.onObjectMoved(options);
    });

    canvas.on("object:added", function(options) {
      self.onObjectAdded(options);
    });

    // object modified
    canvas.on("object:modified", function(options) {
      const unique_id = options.target.windowID;
      const dimensions = self.props.selectedFrame.get("dimensions");

      let leftSpace = options.target.left / self.q;
      let topSpace = options.target.top / self.q;

      if (dimensions !== undefined) {
        leftSpace = leftSpace - parseFloat(dimensions.get("width"));
        topSpace = topSpace - parseFloat(dimensions.get("width"));
      }

      if (unique_id !== undefined) {
        frameCanvas[unique_id]["x"] = leftSpace;
        frameCanvas[unique_id]["y"] = topSpace;
        //console.log(frameCanvas)
      } else {
        plauqeData["x"] = leftSpace;
        plauqeData["y"] = topSpace;
      }
      self.getCanvasData();
      self.generateCanvasImage();
    });
  }

  init() {
    var self = this;
    this.setState({ frameIsLoading: true });
    // Clear canvas upon new mat board selection
    canvas.clear();
    frameCanvas = [];
    plauqeData = { x: 0, y: 0, width: 0, height: 0 };

    const { selectedmatBoard } = this.props;

    // Update canvas dimensions
    this.updateCanvasDimensions();

    // add windows
    for (var y = 0; y < this.props.matBoardWindowSize; y++) {
      const sizeWidth = parseFloat(
        selectedmatBoard.getIn(["mat_data", y, "width"])
      );
      const sizeHeight = parseFloat(
        selectedmatBoard.getIn(["mat_data", y, "height"])
      );
      const sizeX = parseFloat(selectedmatBoard.getIn(["mat_data", y, "x"]));
      const sizeY = parseFloat(selectedmatBoard.getIn(["mat_data", y, "y"]));

      frameCanvas.push({
        id: y,
        height: sizeHeight,
        width: sizeWidth,
        x: sizeX,
        y: sizeY,
      });
    }

    frameCanvas.forEach(this.addWindows);

    // Draw Plaque
    plauqeData["x"] = parseFloat(
      selectedmatBoard.getIn([getPlaqueSize(self.props.plaqueSize), "x"])
    );
    plauqeData["y"] = parseFloat(
      selectedmatBoard.getIn([getPlaqueSize(self.props.plaqueSize), "y"])
    );
    plauqeData["width"] = parseFloat(
      selectedmatBoard.getIn([getPlaqueSize(self.props.plaqueSize), "width"])
    );
    plauqeData["height"] = parseFloat(
      selectedmatBoard.getIn([getPlaqueSize(self.props.plaqueSize), "height"])
    );

    var myfont = new FontFaceObserver("Arial");
    myfont
      .load()
      .then(function() {
        console.log("font loaded");
        self.drawPlaqueInit();
      })
      .catch(function(e) {
        console.log(e);
      });

    // Draw grid and render objects in canvas
    this.drawFrame("init");
    this.drawGridRenderCanvas();
  }

  drawFrame(from) {
    var self = this;
    const { selectedFrame } = this.props;

    this.updateCanvasDimensions();

    if (selectedFrame.size > 0) {
      self.setState({ frameIsLoading: true });
      var frameObject = canvas.getObjects().filter(function(item, key) {
        return item.type === "frameImage";
      });
      if (frameObject.length > 0) {
        for (var o = 0; o < frameObject.length; o++) {
          canvas.remove(frameObject[o]);
        }
      }
      var frameSImage = new Image();
      frameSImage.src = selectedFrame.get("square_image");
      frameSImage.setAttribute("crossOrigin", "anonymous");
      frameSImage.onload = function() {
        var typeWidth = selectedFrame.getIn(["dimensions", "width"]);

        dstFrame = document.createElement("canvas");
        dstFrame.width = self.width;
        dstFrame.height = self.height;
        dstFrameCtx = dstFrame.getContext("2d");

        var ra = frameSImage.height;
        var sa = parseFloat(((self.q * typeWidth) / ra).toFixed(2));
        var ta = parseInt(dstFrame.width / sa, 10);
        var ua = parseInt(dstFrame.height / sa, 10);

        dstFrameCtx.fillStyle = dstFrameCtx.createPattern(
          frameSImage,
          "repeat-x"
        );
        dstFrameCtx.save();
        dstFrameCtx.scale(sa, sa);
        dstFrameCtx.fillRect(0, 0, ta, frameSImage.height);
        dstFrameCtx.restore();
        dstFrameCtx.save();
        dstFrameCtx.scale(sa, sa);
        dstFrameCtx.beginPath();
        dstFrameCtx.translate(ta, ua);
        dstFrameCtx.rotate(180 * v);
        dstFrameCtx.moveTo(0, 0);
        dstFrameCtx.fillRect(0, 0, ta, frameSImage.height);
        dstFrameCtx.rotate(180 * v);
        dstFrameCtx.restore();
        dstFrameCtx.save();
        dstFrameCtx.scale(sa, sa);
        dstFrameCtx.translate(0, ua);
        dstFrameCtx.rotate(-90 * v);
        dstFrameCtx.beginPath();
        dstFrameCtx.moveTo(0, 0);
        dstFrameCtx.lineTo(frameSImage.height, frameSImage.height);
        dstFrameCtx.lineTo(ua - frameSImage.height, frameSImage.height);
        dstFrameCtx.lineTo(ua, 0);
        dstFrameCtx.lineTo(0, 0);
        dstFrameCtx.closePath();
        dstFrameCtx.clip();
        dstFrameCtx.fill();
        dstFrameCtx.rotate(90 * v);
        dstFrameCtx.translate(0, -ua);
        dstFrameCtx.restore();
        dstFrameCtx.save();
        dstFrameCtx.scale(sa, sa);
        dstFrameCtx.translate(ta, 0);
        dstFrameCtx.rotate(90 * v);
        dstFrameCtx.beginPath();
        dstFrameCtx.moveTo(0, 0);
        dstFrameCtx.lineTo(frameSImage.height, frameSImage.height);
        dstFrameCtx.lineTo(ua - frameSImage.height, frameSImage.height);
        dstFrameCtx.lineTo(ua, 0);
        dstFrameCtx.lineTo(0, 0);
        dstFrameCtx.closePath();
        dstFrameCtx.clip();
        dstFrameCtx.fill();
        dstFrameCtx.rotate(-90 * v);
        dstFrameCtx.translate(-ta, 0);
        dstFrameCtx.restore();

        self.updateCanvasDimensions();
        self.drawGridRenderCanvas();

        fabric.Image.fromURL(dstFrame.toDataURL(), function(img) {
          img.set({
            scaleX: dstFrame.width / img.width,
            scaleY: dstFrame.height / img.height,
            top: 0,
            left: 0,
            selectable: false,
            type: "frameImage",
          });
          canvas.add(img);
          //img.sendToBack();
          canvas.setZoom(self.ratio);

          if (from !== "init") {
            frameCanvas.forEach(self.addWindows);
            self.drawPlaqueInit();
          }
          self.getCanvasData();
          self.generateCanvasImage();
          canvas.renderAll();
          self.setState({ frameIsLoading: false });
        });
      };
    }
  }

  getDPI() {
    return 96;
  }

  pxToFontsize(e) {
    return this.pxToMm(e) / 0.5;
  }

  pxToMm(e) {
    return parseFloat(((25.4 * e) / this.getDPI()).toFixed(1));
  }

  drawPlaqueInit() {
    const {
      selectedmatBoard,
      plaqueValues,
      plaqueColour,
      selectedFrame,
      plaqueSize,
    } = this.props;
    if (selectedmatBoard.get("has_plaque") !== "yes") return;

    canvas.remove(plauqeGroup);

    plauqeData["width"] = parseFloat(
      selectedmatBoard.getIn([getPlaqueSize(plaqueSize), "width"])
    );
    plauqeData["height"] = parseFloat(
      selectedmatBoard.getIn([getPlaqueSize(plaqueSize), "height"])
    );

    var pLeft;
    var pTop;

    if (selectedFrame.size > 0) {
      const typeWidth = selectedFrame.getIn(["dimensions", "width"]);
      pTop = (plauqeData["y"] + parseFloat(typeWidth)) * this.q;
      pLeft = (plauqeData["x"] + parseFloat(typeWidth)) * this.q;
    } else {
      pTop = plauqeData["y"] * this.q;
      pLeft = plauqeData["x"] * this.q;
    }

    var plauqeRects = new fabric.Rect({
      top: pTop,
      left: pLeft,
      width: plauqeData["width"] * this.q,
      height: plauqeData["height"] * this.q,
      fill: plaqueColour,
      type: "plauqeRect",
    });

    if (plaqueValues.size > 0) {
      var plauqeText = [];
      var pHeight = 10;
      var leftSpacing = 10;
      for (var i = 0; i < plaqueValues.size; i++) {
        const textAlign = plaqueValues.getIn([i, "align"]);

        switch (textAlign) {
          case "center":
            leftSpacing =
              plauqeRects.left + 0.5 * (plauqeData["width"] * this.q);
            break;
          case "left":
            leftSpacing = plauqeRects.left + 5;
            break;
          case "right":
            leftSpacing = plauqeRects.left + plauqeData["width"] * this.q - 5;
            break;
          default:
            break;
        }

        const plauqes = new fabric.Text(plaqueValues.getIn([i, "text"]), {
          left: leftSpacing,
          originX: textAlign,
          originY: "center",
          fontSize: this.pxToFontsize(plaqueValues.getIn([i, "fontSize"])),
          fontFamily: plaqueValues.getIn([i, "font"]),
          fill: "#000",
          fontWeight: plaqueValues.getIn([i, "bold"]) ? "bold" : "normal",
          underline: plaqueValues.getIn([i, "underline"]) ? true : false,
          fontStyle: plaqueValues.getIn([i, "italic"]) ? "italic" : "normal",
        });

        if (plaqueValues.size === 1)
          plauqes.top = plauqeRects.top + 0.5 * (plauqeData["height"] * this.q);
        else
          plauqes.top =
            plauqeRects.top +
            (plauqeData["height"] * this.q) / (plaqueValues.size * 2) +
            pHeight;

        plauqeText.push(plauqes);
        const textBoundingRect = plauqes.getBoundingRect();
        pHeight = textBoundingRect.height + pHeight;
      }

      var text = new fabric.Group(plauqeText);

      if (
        text.width > parseFloat(plauqeData["width"] * this.q) ||
        text.height > parseFloat(plauqeData["height"] * this.q)
      ) {
        this.props.dispatch({
          type: "SET_STATE",
          state: {
            plaqueError: true,
          },
        });
      } else {
        this.props.dispatch({
          type: "SET_STATE",
          state: {
            plaqueError: false,
          },
        });
      }

      text.type = "plauqeText";
      plauqeGroup = new fabric.Group([plauqeRects, text]);
    } else plauqeGroup = new fabric.Group([plauqeRects]);

    plauqeGroup.hasControls = false;
    plauqeGroup.type = "plauqe";
    plauqeGroup.guides = {};
    canvas.add(plauqeGroup);
    this.getCanvasData();
    setTimeout(() => {
      this.generateCanvasImage();
    }, 2000);
  }

  onObjectAdded(e) {
    // Add the smart guides around the object
    const obj = e.target;

    if (!(obj instanceof fabric.Group)) return false;

    this.drawObjectGuides(obj);
  }

  onObjectMoved(e) {
    // Add the smart guides around the object
    const obj = e.target;
    if (!(obj instanceof fabric.Group)) return false;
    this.drawObjectGuides(obj);
  }

  onObjectMoving(e) {
    const obj = e.target;

    if (!(obj instanceof fabric.Group)) return false;

    this.drawObjectGuides(obj);

    /**
      Implement edge detection here
    */

    // Loop through each object in canvas

    const objects = canvas
      .getObjects()
      .filter((o) => o.type !== "line" && o !== obj);
    // var {bl,br,tl,tr} = obj.oCoords
    const matches = new Set();

    for (var i of objects) {
      //i.set('opacity', obj.intersectsWithObject(i) ? 0.5 : 1);

      for (var side in obj.guides) {
        var axis, newPos;
        switch (side) {
          case "right":
            axis = "left";
            newPos = i.guides[side][axis] - obj.getScaledWidth();
            break;
          case "bottom":
            axis = "top";
            newPos = i.guides[side][axis] - obj.getScaledHeight();
            break;
          case "centerX":
            axis = "left";
            newPos = i.guides[side][axis] - obj.getScaledWidth() / 2;
            break;
          case "centerY":
            axis = "top";
            newPos = i.guides[side][axis] - obj.getScaledHeight() / 2;
            break;
          default:
            axis = side;
            newPos = i.guides[side][axis];
            break;
        }

        if (this.inRange(obj.guides[side][axis], i.guides[side][axis])) {
          matches.add(side);
          this.snapObject(obj, axis, newPos);
        }

        if (side === "left") {
          if (this.inRange(obj.guides["left"][axis], i.guides["right"][axis])) {
            matches.add(side);
            this.snapObject(obj, axis, i.guides["right"][axis]);
          }
        } else if (side === "right") {
          if (this.inRange(obj.guides["right"][axis], i.guides["left"][axis])) {
            matches.add(side);
            this.snapObject(
              obj,
              axis,
              i.guides["left"][axis] - obj.getScaledWidth()
            );
          }
        } else if (side === "top") {
          if (this.inRange(obj.guides["top"][axis], i.guides["bottom"][axis])) {
            matches.add(side);
            this.snapObject(obj, axis, i.guides["bottom"][axis]);
          }
        } else if (side === "bottom") {
          if (this.inRange(obj.guides["bottom"][axis], i.guides["top"][axis])) {
            matches.add(side);
            this.snapObject(
              obj,
              axis,
              i.guides["top"][axis] - obj.getScaledHeight()
            );
          }
        } else if (side === "centerX") {
          if (
            this.inRange(obj.guides["centerX"][axis], i.guides["left"][axis])
          ) {
            matches.add(side);
            this.snapObject(
              obj,
              axis,
              i.guides["left"][axis] - obj.getScaledWidth() / 2
            );
          } else if (
            this.inRange(obj.guides["centerX"][axis], i.guides["right"][axis])
          ) {
            matches.add(side);
            this.snapObject(
              obj,
              axis,
              i.guides["right"][axis] - obj.getScaledWidth() / 2
            );
          }
        } else if (side === "centerY") {
          if (
            this.inRange(obj.guides["centerY"][axis], i.guides["top"][axis])
          ) {
            matches.add(side);
            this.snapObject(
              obj,
              axis,
              i.guides["top"][axis] - obj.getScaledHeight() / 2
            );
          } else if (
            this.inRange(obj.guides["centerY"][axis], i.guides["bottom"][axis])
          ) {
            matches.add(side);
            this.snapObject(
              obj,
              axis,
              i.guides["bottom"][axis] - obj.getScaledHeight() / 2
            );
          }
        }
      }
    }

    for (var k of matches) {
      obj.guides[k].set("opacity", 1);
    }

    obj.setCoords();
  }

  // If the 2 different coordinates are in range
  inRange(a, b) {
    return Math.abs(a - b) <= 10;
  }

  snapObject(obj, side, pos) {
    obj.set(side, pos);
    obj.setCoords();
    this.drawObjectGuides(obj);
  }

  drawObjectGuides(obj) {
    const w = obj.getScaledWidth();
    const h = obj.getScaledHeight();
    this.drawGuide("top", obj.top, obj);
    this.drawGuide("left", obj.left, obj);
    this.drawGuide("centerX", obj.left + w / 2, obj);
    this.drawGuide("centerY", obj.top + h / 2, obj);
    this.drawGuide("right", obj.left + w, obj);
    this.drawGuide("bottom", obj.top + h, obj);
    obj.setCoords();
  }

  drawGuide(side, pos, obj) {
    console.log(obj);
    return;
    var ln;
    var color = "rgb(255,0,0)";
    var lineProps = {
      left: 0,
      top: 0,
      evented: true,
      stroke: color,
      selectable: false,
      opacity: 0,
    };
    switch (side) {
      case "top":
        ln = new fabric.Line(
          [0, 0, canvas.width * this.q, 0],
          Object.assign(lineProps, {
            left: 0,
            top: pos,
          })
        );
        break;
      case "bottom":
        ln = new fabric.Line(
          [0, 0, canvas.width * this.q, 0],
          Object.assign(lineProps, {
            left: 0,
            top: pos,
          })
        );
        break;

      case "centerY":
        ln = new fabric.Line(
          [0, 0, canvas.width * this.q, 0],
          Object.assign(lineProps, {
            left: 0,
            top: pos,
          })
        );
        break;

      case "left":
        ln = new fabric.Line(
          [0, canvas.height * this.q, 0, 0],
          Object.assign(lineProps, {
            left: pos,
            top: 0,
          })
        );
        break;
      case "right":
        ln = new fabric.Line(
          [0, canvas.height * this.q, 0, 0],
          Object.assign(lineProps, {
            left: pos,
            top: 0,
          })
        );
        break;
      case "centerX":
        ln = new fabric.Line(
          [0, canvas.height * this.q, 0, 0],
          Object.assign(lineProps, {
            left: pos,
            top: 0,
          })
        );
        break;
    }

    if (obj.guides[side] instanceof fabric.Line) {
      // remove the line
      canvas.remove(obj.guides[side]);
      delete obj.guides[side];
    }
    obj.guides[side] = ln;
    canvas.add(ln).renderAll();
  }

  addWindows = (options) => {
    var self = this;
    const {
      selectedMatSize,
      selectedMiddleMat,
      windowSizes,
      selectedFrame,
    } = this.props;

    const windowOptions = Object.assign({}, options);

    const sizeWidth = windowOptions.width * this.q;
    const sizeHeight = windowOptions.height * this.q;

    var sizeX;
    var sizeY;

    if (selectedFrame.size > 0) {
      const typeWidth = selectedFrame.getIn(["dimensions", "width"]);
      sizeX = (windowOptions.x + parseFloat(typeWidth)) * this.q;
      sizeY = (windowOptions.y + parseFloat(typeWidth)) * this.q;
    } else {
      sizeX = windowOptions.x * this.q;
      sizeY = windowOptions.y * this.q;
    }

    // middle mats
    const strokeWidth = 1;
    var middleRects = new fabric.Rect({
      originX: "left",
      originY: "top",
      left: sizeX,
      top: sizeY,
      width: sizeWidth + matWidth * 2 - strokeWidth,
      height: sizeHeight + matWidth * 2 - strokeWidth,
      fill:
        parseFloat(selectedMatSize) === 2
          ? selectedMiddleMat.getIn(["acf", "color"])
          : "#fff",
      stroke: "#D3D3D3",
      strokeWidth: strokeWidth,
    });

    // original windows
    var rects = new fabric.Rect({
      originX: "left",
      originY: "top",
      left: sizeX + matWidth,
      top: sizeY + matWidth,
      width: sizeWidth - strokeWidth,
      height: sizeHeight - strokeWidth,
      fill: "#fff",
      stroke: "#D3D3D3",
      strokeWidth: strokeWidth,
      shadow: "rgba(68,68,68,0.5) 0 5px 5px",
    });

    //rects.center();

    // draw text
    const dim = windowOptions.width + "x" + windowOptions.height + "cm";
    var text = new fabric.Text(dim, {
      left: rects.left,
      top: rects.top,
      fill: "#000",
      textAlign: "center",
      fontSize: 26,
      fontFamily: "Arial",
    });

    // Draw image
    if (
      windowSizes.size > 0 &&
      windowSizes.getIn([windowOptions.id, "uploadedFile"]) !== "" &&
      windowSizes.getIn([windowOptions.id, "uploadedFile"]) !== undefined
    ) {
      fabric.Image.fromURL(
        windowSizes.getIn([windowOptions.id, "uploadedFile"]),
        function(img) {
          img.set({
            scaleX: sizeWidth / img.width,
            scaleY: sizeHeight / img.height,
            top: sizeY + matWidth,
            left: sizeX + matWidth,
            originX: "left",
            originY: "top",
          });
          var newgroup = new fabric.Group([middleRects, rects, img, text]);
          newgroup.hasControls = false;
          newgroup.windowID = windowOptions.id;
          newgroup.type = "window";
          newgroup.guides = {};
          canvas.add(newgroup);
          self.setState({ frameIsLoading: false });
          self.getCanvasData();
          setTimeout(() => {
            self.generateCanvasImage();
          }, 2000);
        }
      );
    } else {
      var newgroup = new fabric.Group([middleRects, rects, text], {
        subTargetCheck: true,
      });
      newgroup.hasControls = false;
      newgroup.windowID = windowOptions.id;
      newgroup.type = "window";
      newgroup.guides = {};
      canvas.add(newgroup);
      self.setState({ frameIsLoading: false });
      self.getCanvasData();
      self.generateCanvasImage();
    }
  };

  updateObj() {
    const { windowSizes, updatingWindow } = this.props;
    frameCanvas[updatingWindow]["height"] = parseFloat(
      windowSizes.getIn([updatingWindow, "height"])
    );
    frameCanvas[updatingWindow]["width"] = parseFloat(
      windowSizes.getIn([updatingWindow, "width"])
    );
    frameCanvas[updatingWindow]["x"] = parseFloat(
      windowSizes.getIn([updatingWindow, "x"])
    );
    frameCanvas[updatingWindow]["y"] = parseFloat(
      windowSizes.getIn([updatingWindow, "y"])
    );
    this.updateCanvas();
  }

  updateCanvasForFrame() {
    this.setState({ frameIsLoading: true });
    canvas.clear();
    this.drawFrame();
  }

  updateCanvas() {
    this.setState({ frameIsLoading: true });
    canvas.clear();
    this.updateCanvasDimensions();
    frameCanvas.forEach(this.addWindows);
    this.drawPlaqueInit();
    this.drawFrame("init");
    this.drawGridRenderCanvas();
  }

  updateCanvasDimensions() {
    const { selectedTopMat } = this.props;
    canvas.backgroundColor =
      selectedTopMat.size > 0 ? selectedTopMat.getIn(["acf", "color"]) : "#fff";

    canvas.setWidth(this.width * this.ratio);
    canvas.setHeight(this.height * this.ratio);
  }

  getCanvasData() {
    const { selectedmatBoard, plaqueColour } = this.props;

    var allObjects = canvas._objects.filter(function(item, key) {
      return item.type !== "line";
    });

    //console.log(allObjects, "allObjects")

    matWindowValues = [];
    matPlauqeValues = [];
    for (var a = 0; a < allObjects.length; a++) {
      //console.log(allObjects[a].type, "type")
      switch (allObjects[a].type) {
        case "window":
          matWindowValues.push({
            window: a + 1,
            left: (allObjects[a].left / this.q).toFixed(1),
            top: (allObjects[a].top / this.q).toFixed(1),
            width: (allObjects[a].width / this.q).toFixed(1),
            height: (allObjects[a].height / this.q).toFixed(1),
            windowID: allObjects[a].windowID,
            type: "window",
          });
          break;
        case "plauqe":
          var plauqeObjects = allObjects[a].getObjects();
          //console.log(plauqeObjects, "plauqeObjects")
          for (var p = 0; p < plauqeObjects.length; p++) {
            switch (plauqeObjects[p].type) {
              case "plauqeRect":
                if (selectedmatBoard.get("has_plaque") === "yes") {
                  matPlauqeValues.push({
                    left: (allObjects[a].left / this.q).toFixed(1),
                    top: (allObjects[a].top / this.q).toFixed(1),
                    width: (allObjects[a].width / this.q).toFixed(1),
                    height: (allObjects[a].height / this.q).toFixed(1),
                    fill: plaqueColour,
                  });
                }
                break;
              default:
            }
          }
          break;
        default:
      }
    }

    matWindowValues.sort(function(a, b) {
      return a.windowID - b.windowID;
    });

    //console.log(matWindowValues, "matWindowValues");

    this.props.dispatch({
      type: "SET_STATE",
      state: {
        matWindowValues: matWindowValues,
        matPlauqeValues: matPlauqeValues,
      },
    });
  }

  drawGridRenderCanvas() {
    const { isGrid } = this.props;
    // 1cm Grid across canvas
    grid = 0.5 * this.q;
    if (isGrid) {
      for (var i = 0; i < (this.width * this.q) / grid; i++) {
        canvas.add(
          new fabric.Line([i * grid, 0, i * grid, this.width * this.q], {
            stroke: "#ccc",
            selectable: false,
            type: "line",
          })
        );
        canvas.add(
          new fabric.Line([0, i * grid, this.width * this.q, i * grid], {
            stroke: "#ccc",
            selectable: false,
            type: "line",
          })
        );
      }
    }
    // Set canvas zoom
    canvas.setZoom(this.ratio);
    // Render canvas
    canvas.renderAll();
  }

  generateCanvasImage() {
    this.props.dispatch({
      type: "SET_STATE",
      state: {
        canvasImage: canvas.toDataURL(),
      },
    });
    this.generateThumb(canvas.toDataURL());
  }

  generateThumb(dataURL) {
    var self = this;
    var thumbSize = 250;
    var canvasThumb = document.getElementById("framepreview");

    var thumbDim = Math.min(
      thumbSize / canvasThumb.width,
      thumbSize / canvasThumb.height
    );

    var canvasThumbEle = document.createElement("canvas");
    canvasThumbEle.width = Math.floor(canvasThumb.width * thumbDim);
    canvasThumbEle.height = Math.floor(canvasThumb.height * thumbDim);
    var thumbContext = canvasThumbEle.getContext("2d");

    var imgCanvas = new Image();
    imgCanvas.onload = function(e) {
      thumbContext.fillStyle = "#FFFFFF";
      thumbContext.fillRect(0, 0, canvasThumbEle.width, canvasThumbEle.height);
      thumbContext.scale(thumbDim, thumbDim);
      thumbContext.drawImage(canvasThumb, 0, 0);
      self.props.dispatch({
        type: "SET_STATE",
        state: {
          canvasThumbImage: canvasThumbEle.toDataURL(),
        },
      });
    };
    imgCanvas.src = dataURL;
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    const has_update_in_action = $(event.target)
      .closest(".under_the_image")
      .attr("class");
    if (
      this.wrapperRef &&
      !this.wrapperRef.current.contains(event.target) &&
      has_update_in_action === undefined
    ) {
      $(".under_the_image").hide("fast");
      $(".cont_rgt_middle_table").show("fast");
    }
  }

  render() {
    //console.log(this.state.frameIsLoading)
    const canvasOuter = classNames("canvas-outer", {
      hidden: this.state.frameIsLoading,
    });
    return (
      <div ref={this.wrapperRef}>
        {this.state.frameIsLoading && (
          <div className="canvas-image">
            <Loader />
          </div>
        )}
        <div className={canvasOuter}>
          <canvas id="framepreview"></canvas>
        </div>
      </div>
    );
  }
}
